import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7f21dd52")

_pushScopeId("data-v-7f21dd52")
const _hoisted_1 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_5 = {
  key: 0,
  style: {"color":"#FF7209"}
}
const _hoisted_6 = { class: "feature-plan-form-item" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", {
  style: {"color":"#ff4949"},
  class: "margin-right5px"
}, "*", -1)
const _hoisted_8 = { class: "div-button" }
const _hoisted_9 = { class: "info-item-bottom" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", {
  style: {"color":"#ff4949"},
  class: "margin-right5px"
}, "*", -1)
const _hoisted_11 = { class: "display-flex" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "width5px" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "info-title-bottom" }, null, -1)
const _hoisted_14 = { class: "dialog-footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_input = _resolveComponent("el-input")
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_instructions_dialog = _resolveComponent("instructions-dialog")
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock(_component_dialog_shell, {
    title: _ctx.titles[_ctx.operaType],
    footerType: "customize",
    onClose: _cache[22] || (_cache[22] = ($event: any) => (_ctx.$emit('close'))),
    onSubmit: _ctx.submit
  }, {
    footer: _withId(() => [
      _createVNode("span", _hoisted_14, [
        (_ctx.operaType == 'edit')
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              onClick: _ctx.deleteOffice,
              type: "danger",
              style: {"float":"left"}
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$wordList.ListInHtmlDelete), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.$emit('close')))
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootCancel), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.submit
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootSubmit), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withId(() => [
      (_ctx.operaType === 'add')
        ? (_openBlock(), _createBlock("label", _hoisted_1, [
            _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextComTips), 1),
            _hoisted_2,
            _hoisted_3
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_form, {
        ref: "form",
        "label-position": _ctx.$formLabelPosition,
        rules: _ctx.rules,
        model: _ctx.formData
      }, {
        default: _withId(() => [
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextLandlineService
          }, {
            default: _withId(() => [
              _createVNode(_component_el_radio, {
                modelValue: _ctx.formData.EnableLandline,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.EnableLandline = $event)),
                label: "1",
                disabled: _ctx.operaType === 'edit'
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextOn), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"]),
              _createVNode(_component_el_radio, {
                modelValue: _ctx.formData.EnableLandline,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.EnableLandline = $event)),
                label: "0",
                disabled: _ctx.operaType === 'edit'
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextOff), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"]),
              _hoisted_4,
              (_ctx.formData.EnableLandline === '1')
                ? (_openBlock(), _createBlock("label", _hoisted_5, _toDisplayString(_ctx.$wordList.LandlineIsPremium), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["label"]),
          (!(_ctx.operaType==='edit'&&_ctx.formData.IsNew==='0'))
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                disabled: _ctx.operaType==='edit'
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_6, [
                    _createVNode("span", null, [
                      _hoisted_7,
                      _createTextVNode(" " + _toDisplayString(_ctx.$wordList.ProperAllTextFeaturePlan), 1)
                    ]),
                    _createVNode("div", _hoisted_8, [
                      _createVNode("span", {
                        class: "click-style margin-left20px",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowInstructionsDialog=true))
                      }, _toDisplayString(_ctx.$wordList.ProperAllTextReadInstructions), 1)
                    ])
                  ]),
                  _createVNode(_component_el_radio_group, {
                    modelValue: _ctx.formData.FeaturePlan,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.FeaturePlan = $event)),
                    class: "width100per"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_row, null, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.featurePlanData, (item) => {
                            return (_openBlock(), _createBlock(_component_el_col, {
                              span: 8,
                              key: item.ID
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_radio, {
                                  label: item.ID,
                                  disabled: _ctx.operaType==='edit'
                                }, {
                                  default: _withId(() => [
                                    _createTextVNode(_toDisplayString(item.Name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "disabled"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextOfficeName,
            prop: "Location"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.Location,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.Location = $event)),
                placeholder: _ctx.$wordList.ProperAllTextOfficeName
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode("p", _hoisted_9, [
            _hoisted_10,
            _createTextVNode(" " + _toDisplayString(_ctx.$wordList.BillInHtmlAddress), 1)
          ]),
          _createVNode(_component_el_form_item, { prop: "Country" }, {
            default: _withId(() => [
              _createVNode(_component_cus_select, {
                filter: "",
                modelValue: _ctx.formData.Country,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.Country = $event)),
                width: "100%",
                onChange: _ctx.changeProvinceOption,
                placeholder: _ctx.$wordList.ProperAllTextCountryRegion
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.countryOption, (item) => {
                    return (_openBlock(), _createBlock(_component_cus_option, {
                      key: item,
                      value: item.value,
                      label: item.label
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange", "placeholder"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { prop: "States" }, {
            default: _withId(() => [
              _createVNode(_component_cus_select, {
                filter: "",
                modelValue: _ctx.formData.States,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formData.States = $event)),
                width: "100%",
                disabled: _ctx.provinceDisabled,
                onChange: _ctx.changeCityOption,
                placeholder: _ctx.$wordList.TabelCommunitiesState
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.provinceOption, (item) => {
                    return (_openBlock(), _createBlock(_component_cus_option, {
                      key: item,
                      value: item.value,
                      label: item.label
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled", "onChange", "placeholder"])
            ]),
            _: 1
          }),
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_el_form_item, {
              class: "flex2",
              prop: "City",
              style: {"padding-top":"5px"}
            }, {
              default: _withId(() => [
                _createVNode(_component_cus_select, {
                  filter: "",
                  modelValue: _ctx.formData.City,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formData.City = $event)),
                  width: "100%",
                  disabled: _ctx.cityDisabled,
                  placeholder: _ctx.$wordList.BillInHtmlCity
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cityOption, (item) => {
                      return (_openBlock(), _createBlock(_component_cus_option, {
                        key: item,
                        value: item.value,
                        label: item.label
                      }, null, 8, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled", "placeholder"])
              ]),
              _: 1
            }),
            _hoisted_12,
            _createVNode(_component_el_form_item, {
              class: [_ctx.postClass, "flex1 break-word"],
              prop: "PostalCode"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  onBlur: _ctx.postcodeBlur,
                  modelValue: _ctx.formData.PostalCode,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formData.PostalCode = $event)),
                  placeholder: _ctx.$wordList.TabelBillPostCode
                }, null, 8, ["onBlur", "modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createVNode(_component_el_form_item, { prop: "Street" }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.Street,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.formData.Street = $event)),
                onBlur: _ctx.streetBlur,
                placeholder: _ctx.$wordList.BillInHtmlStreet
              }, null, 8, ["modelValue", "onBlur", "placeholder"])
            ]),
            _: 1
          }),
          _hoisted_13,
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.DarshbordTimeZone
          }, {
            default: _withId(() => [
              _createVNode(_component_cus_select, {
                modelValue: _ctx.formData.TimeZone,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.formData.TimeZone = $event)),
                filter: "",
                "no-data-text": _ctx.$wordList.ListNoData,
                "no-match-text": _ctx.$wordList.ListNoData
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.timeZone.timeZoneOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_cus_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "no-data-text", "no-match-text"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.NavInHtmlTimeFormat
          }, {
            default: _withId(() => [
              _createVNode(_component_el_radio, {
                class: "radio",
                modelValue: _ctx.formData.TimeFormat,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.formData.TimeFormat = $event)),
                label: 2
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString("24" + _ctx.$wordList.NavInHtmlHourFormat), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_radio, {
                class: "radio",
                modelValue: _ctx.formData.TimeFormat,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.formData.TimeFormat = $event)),
                label: 1
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString("12" + _ctx.$wordList.NavInHtmlHourFormat), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.NavInHtmlDateFormat
          }, {
            default: _withId(() => [
              _createVNode(_component_cus_select, {
                modelValue: _ctx.formData.DateFormat,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.formData.DateFormat = $event)),
                placeholder: ""
              }, {
                default: _withId(() => [
                  _createVNode(_component_cus_option, {
                    label: 
                            _ctx.$wordList.NavInHtmlYear +
                                '-' +
                                _ctx.$wordList.NavInHtmlMonth +
                                '-' +
                                _ctx.$wordList.NavInHtmlDay
                        ,
                    value: 1
                  }, null, 8, ["label"]),
                  _createVNode(_component_cus_option, {
                    label: 
                            _ctx.$wordList.NavInHtmlMonth +
                                '-' +
                                _ctx.$wordList.NavInHtmlDay +
                                '-' +
                                _ctx.$wordList.NavInHtmlYear
                        ,
                    value: 3
                  }, null, 8, ["label"]),
                  _createVNode(_component_cus_option, {
                    label: 
                            _ctx.$wordList.NavInHtmlDay +
                                '-' +
                                _ctx.$wordList.NavInHtmlMonth +
                                '-' +
                                _ctx.$wordList.NavInHtmlYear
                        ,
                    value: 5
                  }, null, 8, ["label"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.showChargeMode == 0)
            ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$wordList.ProperAllTextChargeMode
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_radio, {
                      modelValue: _ctx.formData.ChargeMode,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.formData.ChargeMode = $event)),
                      label: "1"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextPayAccount), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _withDirectives(_createVNode("div", null, [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$wordList.ProperAllTextSendExpireEmailToPM
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_radio, {
                        modelValue: _ctx.formData.SendExpireEmailType,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.formData.SendExpireEmailType = $event)),
                        label: "2"
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextOn), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_radio, {
                        modelValue: _ctx.formData.SendExpireEmailType,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.formData.SendExpireEmailType = $event)),
                        label: "1"
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextOff), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$wordList.ProperAllTextSendRenewToPM
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_radio, {
                        modelValue: _ctx.formData.SendRenew,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.formData.SendRenew = $event)),
                        label: "1"
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextOn), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_radio, {
                        modelValue: _ctx.formData.SendRenew,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.formData.SendRenew = $event)),
                        label: "0"
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextOff), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ], 512), [
                  [_vShow, _ctx.formData.ChargeMode === '1']
                ])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["label-position", "rules", "model"]),
      (_ctx.isShowInstructionsDialog)
        ? (_openBlock(), _createBlock(_component_instructions_dialog, {
            key: 1,
            onClose: _cache[21] || (_cache[21] = ($event: any) => (_ctx.isShowInstructionsDialog=false)),
            "project-type": "office"
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "onSubmit"]))
})